(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[26],{

/***/ 640:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var deselectCurrent = __webpack_require__(1742);

var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  "default": "Text"
}

var defaultMessage = "Copy to clipboard: #{key}, Enter";

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug,
    message,
    reselectPrevious,
    range,
    selection,
    mark,
    success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement("span");
    mark.textContent = text;
    // avoid screen readers from reading out loud the text
    mark.ariaHidden = "true"
    // reset user styles for span element
    mark.style.all = "unset";
    // prevents scrolling to the end of the page
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = "pre";
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function(e) {
      e.stopPropagation();
      if (options.format) {
        e.preventDefault();
        if (typeof e.clipboardData === "undefined") { // IE 11
          debug && console.warn("unable to use e.clipboardData");
          debug && console.warn("trying IE specific stuff");
          window.clipboardData.clearData();
          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"]
          window.clipboardData.setData(format, text);
        } else { // all other browsers
          e.clipboardData.clearData();
          e.clipboardData.setData(options.format, text);
        }
      }
      if (options.onCopy) {
        e.preventDefault();
        options.onCopy(e.clipboardData);
      }
    });

    document.body.appendChild(mark);

    range.selectNodeContents(mark);
    selection.addRange(range);

    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(options.format || "text", text);
      options.onCopy && options.onCopy(window.clipboardData);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

module.exports = copy;


/***/ }),

/***/ 528:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard",
      function () {
        return __webpack_require__(1270);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_Utils_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3091);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);





var ContactForm = function(param) {
    var title = param.title, subtitle = param.subtitle;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), result = ref[0], setResult = ref[1];
    var onSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(e) {
            var response, result;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        setResult("Sending");
                        return [
                            4,
                            fetch("https://api.web3forms.com/submit", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    Accept: "application/json"
                                },
                                body: JSON.stringify({
                                    access_key: "be1e603e-89d8-4469-8610-8b5b79eeeb8d",
                                    subject: e.target.subject.value,
                                    email: e.target.email.value,
                                    message: e.target.message.value
                                })
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        result = _state.sent();
                        if (result.success) {
                            console.log("Success");
                            setResult("Success");
                        } else {
                            setResult("Error");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "mb-4 text-4xl tracking-tight font-extrabold text-center",
                children: title
            }),
            subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "mb-8 lg:mb-16 font-light text-center sm:text-xl",
                children: subtitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                onSubmit: onSubmit,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                htmlFor: "email",
                                className: "block mb-2 text-sm font-medium",
                                children: "Your email"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                type: "email",
                                id: "email",
                                name: "email",
                                className: "shadow-sm input input-bordered w-full",
                                placeholder: "name@aiexcelbot.com",
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                htmlFor: "subject",
                                className: "block mb-2 text-sm font-medium",
                                children: "Subject"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                type: "text",
                                id: "subject",
                                name: "subject",
                                className: "input input-bordered w-full",
                                placeholder: "Let us know how we can help you",
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "sm:col-span-2 mb-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                htmlFor: "message",
                                className: "block mb-2 text-sm font-medium",
                                children: "Your message"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                                id: "message",
                                name: "message",
                                rows: 6,
                                className: "block p-2.5 w-full textarea textarea-bordered",
                                placeholder: "Leave a comment..."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mb-4",
                        children: [
                            result === "Success" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "border border-success p-4 rounded-lg",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Email sent successfully. We will write back to you soon."
                                })
                            }),
                            result === "Error" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "border border-error p-4 rounded-lg",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Error sending email. Please try again"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Utils_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        type: "submit",
                        loading: result === "Sending",
                        children: "Send Message"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContactForm);


/***/ }),

/***/ 4516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _stripe_products__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(896);
/* harmony import */ var _utils_AuthContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6864);





var PricingTable = function(param) {
    var showFree = param.showFree;
    var user = (0,_utils_AuthContext__WEBPACK_IMPORTED_MODULE_4__/* .useUser */ .a)().user;
    var _pricing = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var tempPricing = _stripe_products__WEBPACK_IMPORTED_MODULE_3__/* .pricing */ .D;
        // remove free items
        if (!showFree) {
            tempPricing = _stripe_products__WEBPACK_IMPORTED_MODULE_3__/* .pricing.filter */ .D.filter(function(p) {
                return p.title !== "Free";
            });
        }
        // remove items based on logged in user
        if (user) {
            tempPricing = tempPricing.filter(function(p) {
                return p.displayLoggedIn;
            });
        } else {
            tempPricing = tempPricing.filter(function(p) {
                return p.displayLoggedOut;
            });
        }
        return tempPricing;
    }, [
        showFree,
        user
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "mobile-padding-disable p-6 mx-auto max-w-screen-xl lg:py-16 lg:px-6",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    gridTemplateColumns: "".concat(showFree ? "repeat(3, minmax(0, 400px))" : "repeat(2, minmax(0, 400px))")
                },
                className: "space-y-8 flex flex-wrap lg:grid sm:gap-6 xl:gap-6 lg:space-y-0 gap-6",
                children: _pricing.map(function(p, i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative flex flex-col justify-between p-6 mx-auto max-w-lg text-center rounded-lg xl:p-8 ".concat(p.isAnnual ? "bg-gradient-to-b from-[#C0F4CC] to-[#F0FCF2] border border-[#419547] rounded-none rounded-b-lg" : "bg-white border-2"),
                        children: [
                            p.isAnnual && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                style: {
                                    width: "calc(100% + 2px)"
                                },
                                className: "bg-[#419547] absolute -top-[36px] -left-[1px] h-[36px] flex items-center justify-center text-[12px] font-semibold text-[#FFFFFF] rounded-t-2xl",
                                children: "Best Value"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                className: "text-[23px] font-bold flex items-center justify-between text-left gap-2",
                                children: [
                                    p.title,
                                    p.isAnnual && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "h-[24px] text-[12px] px-2 bg-[#419547] text-[#FFFFFF] flex items-center justify-center rounded-full",
                                        children: "Save 30%"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "text-[33px] font-extrabold leading-[40px] flex items-baseline",
                                children: [
                                    p.price,
                                    p.isAnnual ? "/year" : "/month"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "h-[1px] w-full ".concat(p.isAnnual ? "bg-[#419547]" : "bg-[#BFC2CA]", " my-4")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                role: "list",
                                className: "mb-8 space-y-4 text-left",
                                children: p.benefits.map(function(b, j) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                        className: "flex items-center justify-between space-x-3",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex items-center gap-2",
                                                children: [
                                                    p.isAnnual ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        src: "/check-annual.svg",
                                                        alt: ""
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        src: "/check-default.svg",
                                                        alt: ""
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "text-[14px] text-[#2E3443]",
                                                        children: b
                                                    })
                                                ]
                                            }),
                                            b === "Access to our Chrome extension" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                width: 24,
                                                src: "/sheets-logo.svg",
                                                alt: ""
                                            }),
                                            b === "Access to our Excel add-in" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                width: 32,
                                                src: "/excel-logo.svg",
                                                alt: ""
                                            })
                                        ]
                                    }, j);
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-full",
                                children: user ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    href: "/checkout/".concat(p.priceId, "/").concat(p.title),
                                    children: p.isAnnual ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "bg-[#6BD47B] w-full text-[#2E3443] font-bold h-[60px] rounded-lg border border-[#6BD47B]",
                                        children: "Upgrade to Pro"
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "bg-[#FFFFFF] w-full text-[#2E3443] font-bold h-[60px] rounded-lg border border-[#2E3443]",
                                        children: "Upgrade to Pro"
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    href: user ? "/dashboard" : "/signup",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        children: p.isAnnual ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            className: "bg-[#6BD47B] w-full text-[#2E3443] font-bold h-[60px] rounded-lg border border-[#6BD47B]",
                                            children: "Get started"
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            className: "bg-[#FFFFFF] w-full text-[#2E3443] font-bold h-[60px] rounded-lg border border-[#2E3443]",
                                            children: "Get started"
                                        })
                                    })
                                })
                            })
                        ]
                    }, i);
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PricingTable);


/***/ }),

/***/ 3091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2070);


var Button = function(param) {
    var children = param.children, _onClick = param.onClick, onClick = _onClick === void 0 ? function() {} : _onClick, _variant = param.variant, variant = _variant === void 0 ? "Default" : _variant, _loading = param.loading, loading = _loading === void 0 ? false : _loading, _loadingText = param.loadingText, loadingText = _loadingText === void 0 ? "Loading..." : _loadingText, _type = param.type, type = _type === void 0 ? "button" : _type;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_1__/* .motion.button */ .E.button, {
        type: type,
        className: "".concat(variant === "Default" ? "font-medium px-5 py-2.5" : "font-semibold px-6 py-3", " ").concat(loading ? "bg-green-600 cursor-not-allowed" : "bg-green-400 hover:bg-green-600 hover:text-white", " text-center text-sm rounded-xl duration-300 flex items-center"),
        whileHover: {
            scale: 1.1
        },
        whileTap: {
            scale: 0.9
        },
        onClick: onClick,
        disabled: loading,
        children: !loading ? children : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    "aria-hidden": "true",
                    role: "status",
                    className: "inline w-4 h-4 mr-3 text-white animate-spin",
                    viewBox: "0 0 100 101",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                            fill: "#E5E7EB"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                            fill: "currentColor"
                        })
                    ]
                }),
                loadingText
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 1270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ dashboard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 42 modules
var axios = __webpack_require__(5121);
// EXTERNAL MODULE: ./store/store.ts + 5 modules
var store = __webpack_require__(6586);
// EXTERNAL MODULE: ./store/slices/accountSlice.ts
var accountSlice = __webpack_require__(730);
// EXTERNAL MODULE: ./store/slices/archiveSlice.ts
var archiveSlice = __webpack_require__(7308);
// EXTERNAL MODULE: ./utils/AuthContext.tsx
var AuthContext = __webpack_require__(6864);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/native.js
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ var esm_browser_native = ({
  randomUUID
});
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = ((/* unused pure expression or super */ null && (stringify)));
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v4.js




function v4(options, buf, offset) {
  if (esm_browser_native.randomUUID && !buf && !options) {
    return esm_browser_native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);
// EXTERNAL MODULE: ./node_modules/react-copy-to-clipboard/lib/index.js
var lib = __webpack_require__(4855);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./components/Utils/Button.tsx
var Button = __webpack_require__(3091);
;// CONCATENATED MODULE: ./components/Utils/InstallAddonCta.tsx

var InstallAddonCta = function(param) {
    var _view = param.view, view = _view === void 0 ? "horizontal" : _view;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "install-addon-block-wrapper ".concat(view === "vertical" ? "vertical" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "addon-block-element",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        style: {
                            marginLeft: "-12px"
                        },
                        className: "addon-block-image",
                        src: "excel-logo.svg",
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        className: "addon-block-title",
                        children: "Ask AI Without Leaving Microsoft Excel"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "addon-block-description",
                        children: "Download our Excel Add-in."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://pages.store.office.com/addinsinstallpage.aspx?assetid=WA200006180&rs=en-US&correlationId=5eea722e-b620-fe83-c791-460662cb32d5",
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "addon-block-button",
                            children: "Download"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "addon-block-element",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        style: {
                            marginLeft: "-5px"
                        },
                        className: "addon-block-image",
                        src: "sheets-logo.svg",
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        className: "addon-block-title",
                        children: "Ask AI Without Leaving Google Sheets"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "addon-block-description",
                        children: "Download our Chrome Extension."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://chrome.google.com/webstore/detail/ai-excel-bot-extension/ehpdalbmeiockgpaikchiciodighaedg",
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "addon-block-button",
                            children: "Download"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Utils_InstallAddonCta = (InstallAddonCta);

// EXTERNAL MODULE: ./node_modules/firebase/auth/dist/index.esm.js + 2 modules
var index_esm = __webpack_require__(7783);
;// CONCATENATED MODULE: ./components/Utils/EmailVerificationCta.tsx






var EmailVerificationCta = function() {
    var user = (0,AuthContext/* useUser */.a)().user;
    var handleSendVerificationEmail = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,index_esm/* sendEmailVerification */.w$)(user)
                        ];
                    case 1:
                        _state.sent();
                        alert("Verification email sent. You may need to look into your spam folder.");
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSendVerificationEmail() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full mb-4 md:w-3/4 p-4 mt-4 flex flex-col gap-4 rounded-xl bg-white border",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-bold",
                        children: "In order to use AI Excel Bot, users are required to verify email."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "We have sent you a verification email at",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-bold",
                                children: user === null || user === void 0 ? void 0 : user.email
                            }),
                            ". Click the link in the email to verify your account and get access to AI Excel Bot. You may need to look into your spam folder."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Looking forward to see you use AI Excel Bot to it's full potential!"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "Large",
                onClick: handleSendVerificationEmail,
                children: "Resend Verification Email"
            })
        ]
    });
};
/* harmony default export */ var Utils_EmailVerificationCta = (EmailVerificationCta);

;// CONCATENATED MODULE: ./components/Utils/ResubscribeCta.tsx




var ResubscribeCta = function() {
    var oldStripeData = (0,store/* default */.Z)(accountSlice/* selectOldStripeData */.DL);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full ml-8 mb-4 md:w-3/4 p-4 mt-4 flex flex-col gap-4 rounded-xl bg-gradient-to-r from-red-100 to-red-50 border",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "font-bold",
                children: "AI Excel Bot has been acquired by Dream Shake Media LLC."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "We are pleased to offer you a complimentary month of our Pro subscription plan for free, starting from the end date of your current plan. Your free Pro access will end in",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "font-bold",
                        children: [
                            Math.floor((oldStripeData.current_period_end.seconds * 1000 - Date.now()) / 86400000),
                            " ",
                            "days ."
                        ]
                    }),
                    " ",
                    "You will need to resubscribe to our pro plans before the end of this period to continue with your unlimited access."
                ]
            })
        ]
    });
};
/* harmony default export */ var Utils_ResubscribeCta = (ResubscribeCta);

// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(6076);
;// CONCATENATED MODULE: ./components/Query/QueryBuilder.tsx


















var QueryBuilder = function() {
    var user = (0,AuthContext/* useUser */.a)().user;
    var accountData = (0,store/* default */.Z)(accountSlice/* selectAccountData */.pp);
    var oldStripeData = (0,store/* default */.Z)(accountSlice/* selectOldStripeData */.DL);
    var ref = (0,store/* default */.Z)(archiveSlice/* selectArchiveDataActions */.sD), addQuery = ref.addQuery, updateQueryFeedback = ref.updateQueryFeedback;
    var setCreditBalance = (0,store/* default */.Z)(accountSlice/* selectAccountDataActions */.fB).setCreditBalance;
    var ref1 = (0,react.useState)(), currentQuery = ref1[0], setCurrentQuery = ref1[1];
    var ref2 = (0,react.useState)(true), generate = ref2[0], setGenerate = ref2[1];
    var ref3 = (0,react.useState)(false), explain = ref3[0], setExplain = ref3[1];
    var ref4 = (0,react.useState)(true), excel = ref4[0], setExcel = ref4[1];
    var ref5 = (0,react.useState)(false), sheet = ref5[0], setSheet = ref5[1];
    var ref6 = (0,react.useState)(false), loading = ref6[0], setLoading = ref6[1];
    var ref7 = (0,react.useState)(false), copied = ref7[0], setCopied = ref7[1];
    var ref8 = (0,react.useState)(false), loadingFeedback = ref8[0], setLoadingFeedback = ref8[1];
    var ref9 = (0,react.useState)(false), feedbackRegistered = ref9[0], setFeedbackRegistered = ref9[1];
    var ref10 = (0,react.useState)(""), response = ref10[0], setResponse = ref10[1];
    var placeholder = (0,react.useMemo)(function() {
        if (explain) return '=IF(AND(B1>100,REGEXMATCH(C1,"^hello.*goodbye$")),REGEXEXTRACT(A1,"w+sw+sw+s(w+)"),)';
        if (generate) return 'Extract the fourth word in A1 only when cell B1 is greater than 100 and when C1 starts with the word "hello" and ends with the word "goodbye".';
    }, [
        generate,
        explain
    ]);
    var output = (0,react.useMemo)(function() {
        if (generate) return '=IF(AND(B1>100,REGEXMATCH(C1,"^hello.*goodbye$")),REGEXEXTRACT(A1,"w+sw+sw+s(w+)"),)';
        if (explain) return 'Extract the fourth word in A1 only when cell B1 is greater than 100 and when C1 starts with the word "hello" and ends with the word "goodbye".';
    }, [
        generate,
        explain
    ]);
    (0,react.useEffect)(function() {
        var intervalId;
        if (copied) {
            intervalId = setInterval(function() {
                setCopied(false);
            }, 1000);
        }
        return function() {
            clearInterval(intervalId);
        };
    }, [
        copied
    ]);
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var input, res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        if ((accountData === null || accountData === void 0 ? void 0 : accountData.creditBalance) <= 0 && (accountData === null || accountData === void 0 ? void 0 : accountData.isPremium) !== true) {
                            alert("You have used your monthly AI credits. Upgrade to Pro and get unlimited access!");
                            return [
                                2
                            ];
                        }
                        input = e.target.formula.value;
                        if (explain && input.charAt(0) !== "=") {
                            alert("Please provide a valid formula.");
                            return [
                                2
                            ];
                        }
                        setLoading(true);
                        setCopied(false);
                        setResponse("");
                        setCurrentQuery(undefined);
                        setFeedbackRegistered(false);
                        if (!generate) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            axios/* default.post */.Z.post("/api/formula", {
                                query: {
                                    id: esm_browser_v4(),
                                    prompt: input,
                                    operation: "Generate",
                                    type: excel ? "Excel" : "Google Sheets",
                                    isCorrect: null
                                },
                                uid: accountData === null || accountData === void 0 ? void 0 : accountData.uid,
                                creditBalance: !(accountData === null || accountData === void 0 ? void 0 : accountData.isPremium) ? (accountData === null || accountData === void 0 ? void 0 : accountData.creditBalance) - 1 : accountData === null || accountData === void 0 ? void 0 : accountData.creditBalance,
                                creditMax: 5
                            }, {
                                headers: {
                                    // @ts-ignore
                                    Authorization: "Bearer ".concat(user.accessToken),
                                    ExcelBotToken: constants/* EXCEL_BOT_TOKEN */.c
                                }
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            axios/* default.post */.Z.post("/api/explain", {
                                query: {
                                    id: esm_browser_v4(),
                                    prompt: input,
                                    operation: "Explain",
                                    type: excel ? "Excel" : "Google Sheets",
                                    isCorrect: null
                                },
                                uid: accountData === null || accountData === void 0 ? void 0 : accountData.uid,
                                creditBalance: !(accountData === null || accountData === void 0 ? void 0 : accountData.isPremium) ? (accountData === null || accountData === void 0 ? void 0 : accountData.creditBalance) - 1 : accountData === null || accountData === void 0 ? void 0 : accountData.creditBalance,
                                creditMax: 5
                            }, {
                                headers: {
                                    // @ts-ignore
                                    Authorization: "Bearer ".concat(user.accessToken),
                                    ExcelBotToken: constants/* EXCEL_BOT_TOKEN */.c
                                }
                            })
                        ];
                    case 3:
                        res = _state.sent();
                        _state.label = 4;
                    case 4:
                        if (res.status === 200) {
                            window.gtag("event", "query_prompt", {
                                "prompt": input
                            });
                            addQuery(res.data);
                            setCurrentQuery(res.data);
                            setResponse(res.data.response);
                            if (!(accountData === null || accountData === void 0 ? void 0 : accountData.isPremium)) {
                                setCreditBalance((accountData === null || accountData === void 0 ? void 0 : accountData.creditBalance) - 1);
                            }
                        } else {
                            alert("Error generating formula - " + JSON.stringify(res.data));
                        }
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleFeedback = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(isCorrect) {
            var res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoadingFeedback(true);
                        return [
                            4,
                            axios/* default.post */.Z.post("/api/feedback", {
                                uid: accountData === null || accountData === void 0 ? void 0 : accountData.uid,
                                id: currentQuery === null || currentQuery === void 0 ? void 0 : currentQuery.id,
                                operation: currentQuery === null || currentQuery === void 0 ? void 0 : currentQuery.operation,
                                isCorrect: isCorrect,
                                type: "Formula"
                            }, {
                                headers: {
                                    // @ts-ignore
                                    Authorization: "Bearer ".concat(user.accessToken),
                                    ExcelBotToken: constants/* EXCEL_BOT_TOKEN */.c
                                }
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        if (res.status === 200) {
                            updateQueryFeedback(currentQuery === null || currentQuery === void 0 ? void 0 : currentQuery.id, isCorrect);
                            setCurrentQuery((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentQuery), {
                                isCorrect: isCorrect
                            }));
                            setFeedbackRegistered(true);
                        } else {
                            alert("Error registering feedback");
                        }
                        setLoadingFeedback(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleFeedback(isCorrect) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pt-5 pb-10 w-full h-full lg:scrollbar-thin lg:scrollbar-thumb-gray-500 lg:overflow-y-scroll lg:scrollbar-thumb-rounded-full lg:scrollbar-track-rounded-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "pl-8 pb-2 text-3xl font-bold border-b-2",
                children: "Configure Request"
            }),
            oldStripeData && /*#__PURE__*/ (0,jsx_runtime.jsx)(Utils_ResubscribeCta, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "page-content-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full",
                        children: !(user === null || user === void 0 ? void 0 : user.emailVerified) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Utils_EmailVerificationCta, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                    onSubmit: handleSubmit,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm font-medium text-gray-500 mb-2 mt-10",
                                            children: "Is this request for Excel or Google Sheets?"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "grid gap-6 max-w-md md:grid-cols-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            checked: excel,
                                                            onChange: function(e) {
                                                                setSheet(!sheet);
                                                                setExcel(!excel);
                                                            },
                                                            type: "radio",
                                                            id: "excel",
                                                            name: "excel",
                                                            value: "excel",
                                                            className: "hidden peer"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            htmlFor: "excel",
                                                            className: "duration-300 inline-flex items-center justify-between w-full px-5 py-2 text-gray-500 bg-white border border-gray-200 rounded-xl cursor-pointer peer-checked:border-green-600 peer-checked:text-green-600 peer-checked:bg-green-200 hover:text-green-600 hover:bg-green-100",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "w-full text-lg font-semibold",
                                                                children: "Excel"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            checked: sheet,
                                                            onChange: function(e) {
                                                                setSheet(!sheet);
                                                                setExcel(!excel);
                                                            },
                                                            type: "radio",
                                                            id: "sheet",
                                                            name: "sheet",
                                                            value: "sheet",
                                                            className: "hidden peer"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            htmlFor: "sheet",
                                                            className: "duration-300 inline-flex items-center justify-between w-full px-5 py-2 text-gray-500 bg-white border border-gray-200 rounded-xl cursor-pointer peer-checked:border-green-600 peer-checked:text-green-600 peer-checked:bg-green-200 hover:text-green-600 hover:bg-green-100",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "w-full text-lg font-semibold",
                                                                children: "Google Sheets"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm font-medium text-gray-500 mb-2 mt-10",
                                            children: "Do you want to generate a formula or have a formula explained?"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "grid gap-6 max-w-md md:grid-cols-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            checked: generate,
                                                            onChange: function(e) {
                                                                setGenerate(!generate);
                                                                setExplain(!explain);
                                                            },
                                                            type: "radio",
                                                            id: "generate",
                                                            name: "generate",
                                                            value: "generate",
                                                            className: "hidden peer"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            htmlFor: "generate",
                                                            className: "duration-300 inline-flex items-center justify-between w-full px-5 py-2 text-gray-500 bg-white border border-gray-200 rounded-xl cursor-pointer peer-checked:border-green-600 peer-checked:text-green-600 peer-checked:bg-green-200 hover:text-green-600 hover:bg-green-100",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "w-full text-lg font-semibold",
                                                                children: "Generate"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            checked: explain,
                                                            onChange: function(e) {
                                                                setGenerate(!generate);
                                                                setExplain(!explain);
                                                            },
                                                            type: "radio",
                                                            id: "explain",
                                                            name: "explain",
                                                            value: "explain",
                                                            className: "hidden peer"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            htmlFor: "explain",
                                                            className: "duration-300 inline-flex items-center justify-between w-full px-5 py-2 text-gray-500 bg-white border border-gray-200 rounded-xl cursor-pointer peer-checked:border-green-600 peer-checked:text-green-600 peer-checked:bg-green-200 hover:text-green-600 hover:bg-green-100",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "w-full text-lg font-semibold",
                                                                children: "Explain"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm font-medium text-gray-500 mb-2 mt-10",
                                            children: "Type the problem you are trying to solve or formula you want explained. Be as specific as possible"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "form-control mb-5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                                className: "textarea textarea-bordered rounded-xl w-3/4 h-24 ml-2",
                                                placeholder: placeholder,
                                                name: "formula",
                                                required: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                            type: "submit",
                                            loading: loading,
                                            loadingText: "Running AI...",
                                            children: [
                                                "Get ",
                                                generate ? "Formula" : "Explanation"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-sm font-medium text-gray-500 mb-2 mt-10",
                                    children: "Output"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                    className: "textarea textarea-bordered rounded-xl w-3/4 h-24 ml-2 whitespace-pre-wrap",
                                    placeholder: output,
                                    name: "output",
                                    readOnly: true,
                                    value: response,
                                    required: true
                                }),
                                response && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mb-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.CopyToClipboard, {
                                                text: response,
                                                onCopy: function() {
                                                    return setCopied(true);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    type: "button",
                                                    className: "flex items-center gap-2 p-2 mt-3 border rounded-xl ".concat(copied ? "bg-green-300" : "bg-white"),
                                                    children: [
                                                        copied ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "material-icons",
                                                                    children: "done"
                                                                }),
                                                                "Copied"
                                                            ]
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "material-icons",
                                                                    children: "content_copy"
                                                                }),
                                                                "Copy"
                                                            ]
                                                        }),
                                                        " "
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-sm font-medium text-gray-500 mb-2 mt-2",
                                                    children: "Is the output correct?"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex gap-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: "btn btn-sm btn-square btn-success ".concat(loadingFeedback && "loading"),
                                                            onClick: function() {
                                                                return handleFeedback(true);
                                                            },
                                                            disabled: feedbackRegistered,
                                                            children: !loadingFeedback && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "material-icons",
                                                                children: "thumb_up"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: "btn btn-sm btn-square btn-error ".concat(loadingFeedback && "loading"),
                                                            onClick: function() {
                                                                return handleFeedback(false);
                                                            },
                                                            disabled: feedbackRegistered,
                                                            children: !loadingFeedback && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "material-icons",
                                                                children: "thumb_down"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    (user === null || user === void 0 ? void 0 : user.emailVerified) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-8 mb-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Utils_InstallAddonCta, {
                            view: "vertical"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "min-h-[5rem] md:hidden"
            })
        ]
    });
};
/* harmony default export */ var Query_QueryBuilder = (QueryBuilder);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 5 modules
var _to_consumable_array = __webpack_require__(797);
;// CONCATENATED MODULE: ./components/Archive/ArchiveTable.tsx






var Copy = function(param) {
    var text = param.text;
    var ref = (0,react.useState)(false), copied = ref[0], setCopied = ref[1];
    (0,react.useEffect)(function() {
        var intervalId;
        if (copied) {
            intervalId = setInterval(function() {
                setCopied(false);
            }, 1000);
        }
        return function() {
            clearInterval(intervalId);
        };
    }, [
        copied
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
        text: text,
        onCopy: function() {
            return setCopied(true);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
            type: "button",
            className: "flex items-center gap-2 p-2 mt-3 border rounded-xl ".concat(copied ? "bg-green-300" : "bg-white"),
            children: [
                copied ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "material-icons",
                        children: "done"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "material-icons",
                        children: "content_copy"
                    })
                }),
                " "
            ]
        })
    });
};
var ArchiveTable = function() {
    var queries = (0,store/* default */.Z)(archiveSlice/* selectAllQueries */.wi);
    var queriesSorted = (0,react.useMemo)(function() {
        return (0,_to_consumable_array/* default */.Z)(queries).sort(function(a, b) {
            return a.createdAt.seconds - b.createdAt.seconds;
        });
    }, [
        queries
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full h-full",
        children: !queries || queries.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full h-full flex justify-center items-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "No Queries generated, yet!"
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-[90%] rounded-xl border-2 mx-auto relative overflow-x-auto",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                className: "w-full text-sm text-left text-gray-500",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                        className: "text-xs text-gray-700 bg-gray-200",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    scope: "col",
                                    className: "px-6 py-3",
                                    children: "Prompt"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    scope: "col",
                                    className: "px-6 py-3",
                                    children: "Response"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    scope: "col",
                                    className: "px-6 py-3",
                                    children: "Type"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    scope: "col",
                                    className: "px-6 py-3",
                                    children: "Copy"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                        children: queriesSorted.map(function(query, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                className: "bg-white border-b",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        scope: "row",
                                        className: "px-6 py-4 font-medium",
                                        children: query.prompt
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: "px-6 py-4",
                                        children: query.response
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: "px-6 py-4",
                                        children: query.type
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: "px-6 py-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Copy, {
                                            text: query.response
                                        })
                                    })
                                ]
                            }, i);
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Archive_ArchiveTable = (ArchiveTable);

;// CONCATENATED MODULE: ./components/Archive/Archive.tsx


var Archive = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pt-5 pb-10 w-full h-full lg:scrollbar-thin lg:scrollbar-thumb-gray-500 lg:overflow-y-scroll lg:scrollbar-thumb-rounded-full lg:scrollbar-track-rounded-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "pl-8 pb-2 text-3xl font-bold border-b-2",
                children: "Archives"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pl-8 mt-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Archive_ArchiveTable, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "min-h-[5rem] md:hidden"
            })
        ]
    });
};
/* harmony default export */ var Archive_Archive = (Archive);

// EXTERNAL MODULE: ./components/ContactForm/ContactForm.tsx
var ContactForm = __webpack_require__(5328);
;// CONCATENATED MODULE: ./components/Help/HelpTab.tsx



var HelpTab = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pt-5 pb-10 w-full h-full lg:scrollbar-thin lg:scrollbar-thumb-gray-500 lg:overflow-y-scroll lg:scrollbar-thumb-rounded-full lg:scrollbar-track-rounded-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "pl-8 pb-2 text-3xl font-bold border-b-2",
                children: "How to generate accurate formulas?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-[95%] mx-auto my-8 p-4 border-2 bg-white rounded-xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "mb-4",
                        children: [
                            "To ensure that the formulas generated are accurate, users are advised to use the exact column, row or cell names. Even though the AI can figured out what users prompt tries to say, it is advised be as specific with the query as possible.",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-green-700 font-semibold",
                                children: "For example : Sum column A when cell B10 equals the word hello"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "mb-4",
                        children: [
                            "In case of If-Else type of formula always provide the expected output for all the conditions.",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-green-700 font-semibold",
                                children: "For Example : If A1 is greater than 100, add 10 else subtract 10"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "mb-4",
                        children: [
                            "Use Column letters (Column A or Column B) instead of custom header names.",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-green-700 font-semibold",
                                children: "For Example: Calculate the average of cells in column F."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pl-8 mb-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Utils_InstallAddonCta, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-[95%] mx-auto p-4 border-2 bg-white rounded-xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "mb-4 text-xl tracking-tight font-bold",
                        children: "Contact Support"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactForm/* default */.Z, {
                        title: "",
                        subtitle: ""
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "min-h-[5rem] md:hidden"
            })
        ]
    });
};
/* harmony default export */ var Help_HelpTab = (HelpTab);

// EXTERNAL MODULE: ./components/Pricing/PricingTable.tsx
var PricingTable = __webpack_require__(4516);
;// CONCATENATED MODULE: ./components/Profile/Profile.tsx













var Profile = function() {
    var router = (0,next_router.useRouter)();
    var user = (0,AuthContext/* useUser */.a)().user;
    var accountData = (0,store/* default */.Z)(accountSlice/* selectAccountData */.pp);
    var oldStripeData = (0,store/* default */.Z)(accountSlice/* selectOldStripeData */.DL);
    var progressColor = (0,react.useMemo)(function() {
        if (accountData === null || accountData === void 0 ? void 0 : accountData.isPremium) return "progress-success";
        if ((accountData === null || accountData === void 0 ? void 0 : accountData.creditBalance) && (accountData === null || accountData === void 0 ? void 0 : accountData.creditBalance) >= 0 && (accountData === null || accountData === void 0 ? void 0 : accountData.creditMax) && (accountData === null || accountData === void 0 ? void 0 : accountData.creditMax) > 0) {
            var balancePercent = accountData ? 100 * ((accountData === null || accountData === void 0 ? void 0 : accountData.creditBalance) / (accountData === null || accountData === void 0 ? void 0 : accountData.creditMax)) : 0;
            if (balancePercent >= 50) return "progress-success";
            if (balancePercent >= 15 && balancePercent < 50) return "progress-warning";
            if (balancePercent < 15) return "progress-error";
        } else return "progress-error";
    }, [
        accountData
    ]);
    var freeAccessDaysLeft = (0,react.useMemo)(function() {
        if (!oldStripeData) return null;
        return (oldStripeData.current_period_end.seconds * 1000 - Date.now()) / 86400000;
    }, [
        oldStripeData
    ]);
    var handleManageSubscription = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        return [
                            4,
                            axios/* default.post */.Z.post("/api/manage-subscription", {
                                customerId: accountData === null || accountData === void 0 ? void 0 : accountData.stripeCustomerId
                            }, {
                                headers: {
                                    // @ts-ignore
                                    Authorization: "Bearer ".concat(user.accessToken),
                                    ExcelBotToken: constants/* EXCEL_BOT_TOKEN */.c
                                }
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        router.push(res.data);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleManageSubscription(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pt-5 pb-10 w-full h-full lg:scrollbar-thin lg:scrollbar-thumb-gray-500 lg:overflow-y-scroll lg:scrollbar-thumb-rounded-full lg:scrollbar-track-rounded-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "pl-8 pb-2 text-3xl font-bold border-b-2",
                children: "Profile"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pl-8 mt-8 flex gap-10 flex-col md:items-center md:flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "avatar md:online",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-24 rounded-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: accountData === null || accountData === void 0 ? void 0 : accountData.photoURL,
                                alt: accountData === null || accountData === void 0 ? void 0 : accountData.email
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "form-control w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            className: "input-group",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "label-text",
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "text",
                                    className: "input input-bordered w-full max-w-sm",
                                    defaultValue: accountData === null || accountData === void 0 ? void 0 : accountData.email,
                                    disabled: true
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pl-8 mt-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Utils_InstallAddonCta, {})
            }),
            oldStripeData && /*#__PURE__*/ (0,jsx_runtime.jsx)(Utils_ResubscribeCta, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-12 mb-8 pl-8 pb-2 border-b-2 flex gap-4 items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-3xl font-bold",
                        children: "Billing"
                    }),
                    (accountData === null || accountData === void 0 ? void 0 : accountData.isPremium) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-2.5 py-1 text-center text-sm font-medium rounded-full bg-green-400 duration-300 hover:bg-green-600 hover:text-white",
                        children: "Pro User"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lg:w-min lg:ml-8 p-4 border-2 bg-white rounded-xl max-w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-8 flex flex-col md:flex-row justify-start items-start gap-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "stats w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "stat text-base-content w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "stat-figure",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "material-icons",
                                            children: (accountData === null || accountData === void 0 ? void 0 : accountData.creditBalance) ? "hourglass_top" : "hourglass_empty"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "stat-title",
                                        children: "Balance Credits"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "stat-value",
                                        children: [
                                            (accountData === null || accountData === void 0 ? void 0 : accountData.isPremium) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Unlimited"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: (accountData === null || accountData === void 0 ? void 0 : accountData.creditBalance) || 0
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("progress", {
                                                className: "progress ".concat(progressColor, " lg:w-56 w-full"),
                                                value: (accountData === null || accountData === void 0 ? void 0 : accountData.isPremium) ? 1 : (accountData === null || accountData === void 0 ? void 0 : accountData.creditBalance) ? (accountData === null || accountData === void 0 ? void 0 : accountData.creditBalance) + 1 : 1,
                                                max: (accountData === null || accountData === void 0 ? void 0 : accountData.isPremium) ? 1 : (accountData === null || accountData === void 0 ? void 0 : accountData.creditMax) ? (accountData === null || accountData === void 0 ? void 0 : accountData.creditMax) + 1 : 20
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    (accountData === null || accountData === void 0 ? void 0 : accountData.subscriptionId) && !(accountData === null || accountData === void 0 ? void 0 : accountData.subscriptionId.includes("I-")) && !oldStripeData && /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                        onSubmit: handleManageSubscription,
                        className: "mt-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "px-5 py-2.5 text-center text-sm font-medium rounded-xl bg-green-400 duration-300 hover:bg-green-600 hover:text-white",
                            type: "submit",
                            children: "Manage Billing"
                        })
                    })
                ]
            }),
            (!(accountData === null || accountData === void 0 ? void 0 : accountData.subscriptionId) || freeAccessDaysLeft && freeAccessDaysLeft <= 30 || !(accountData === null || accountData === void 0 ? void 0 : accountData.isPremium)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingTable/* default */.Z, {
                showFree: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "min-h-[5rem] md:hidden"
            })
        ]
    });
};
/* harmony default export */ var Profile_Profile = (Profile);

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 161 modules
var motion = __webpack_require__(2070);
;// CONCATENATED MODULE: ./components/Dashboard/LeftPanel.tsx





var links = [
    {
        title: "Playground",
        icon: "smart_toy"
    },
    {
        title: "VBA",
        icon: "code"
    },
    {
        title: "Task AI",
        icon: "headset_mic"
    },
    {
        title: "Archives",
        icon: "archive"
    },
    {
        title: "Help",
        icon: "help"
    },
    {
        title: "Billing",
        icon: "account_circle"
    }, 
];
var LeftPanel = function(param) {
    var user = param.user, tab = param.tab, setTab = param.setTab;
    var logOut = (0,AuthContext/* useUser */.a)().logOut;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "drawer w-60 border-r-2",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "drawer-side",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: "flex flex-col justify-between h-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-8 flex flex-col gap-4 items-center",
                        children: links.map(function(link, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                onClick: function() {
                                    setTab(i);
                                    router.push("/dashboard?tabQueryParam=" + i);
                                },
                                className: "relative w-52 min-h-12 px-4 cursor-pointer",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "w-52 rounded-xl flex gap-4 items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "material-icons",
                                                children: link.icon
                                            }),
                                            link.title,
                                            link.title === "Task AI" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "bg-orange-200 font-semibold px-2 text-sm rounded-full",
                                                children: "new"
                                            })
                                        ]
                                    }),
                                    tab === i && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                        className: "bg-green-200 w-52 h-12 rounded-xl absolute -top-3 left-0 -z-10",
                                        layoutId: "bg"
                                    })
                                ]
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-4 flex flex-col gap-4 items-center",
                        children: user && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "w-52 min-h-12 px-4 cursor-pointer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: "w-52 rounded-xl flex gap-4 items-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "material-icons",
                                                    children: "home"
                                                }),
                                                "Home"
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "w-52 min-h-12 cursor-pointer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "bg-gray-300 p-4 rounded-xl flex gap-4 items-center",
                                        onClick: function() {
                                            return logOut();
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "material-icons",
                                                children: "logout"
                                            }),
                                            "Logout"
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Dashboard_LeftPanel = (LeftPanel);

;// CONCATENATED MODULE: ./components/VbaBuilder/VbaBuilder.tsx


















var VbaBuilder = function() {
    var user = (0,AuthContext/* useUser */.a)().user;
    var accountData = (0,store/* default */.Z)(accountSlice/* selectAccountData */.pp);
    var oldStripeData = (0,store/* default */.Z)(accountSlice/* selectOldStripeData */.DL);
    var ref = (0,store/* default */.Z)(archiveSlice/* selectArchiveDataActions */.sD), addVba = ref.addVba, updateVbaFeedback = ref.updateVbaFeedback;
    var setCreditBalance = (0,store/* default */.Z)(accountSlice/* selectAccountDataActions */.fB).setCreditBalance;
    var ref1 = (0,react.useState)(), currentVba = ref1[0], setCurrentVba = ref1[1];
    var ref2 = (0,react.useState)(true), generate = ref2[0], setGenerate = ref2[1];
    var ref3 = (0,react.useState)(false), explain = ref3[0], setExplain = ref3[1];
    var ref4 = (0,react.useState)(false), loading = ref4[0], setLoading = ref4[1];
    var ref5 = (0,react.useState)(false), copied = ref5[0], setCopied = ref5[1];
    var ref6 = (0,react.useState)(false), loadingFeedback = ref6[0], setLoadingFeedback = ref6[1];
    var ref7 = (0,react.useState)(false), feedbackRegistered = ref7[0], setFeedbackRegistered = ref7[1];
    var ref8 = (0,react.useState)(""), response = ref8[0], setResponse = ref8[1];
    var placeholder = (0,react.useMemo)(function() {
        if (explain) return "Sub Last_Column()\n      Dim LC As Long\n      LC = Cells(1, Columns.Count).End(xlToLeft).Column\n      MsgBox LC\nEnd Sub\n";
        if (generate) return "Find the last used column in the current sheet";
    }, [
        generate,
        explain
    ]);
    var output = (0,react.useMemo)(function() {
        if (generate) return "Sub Last_Column()\n      Dim LC As Long\n      LC = Cells(1, Columns.Count).End(xlToLeft).Column\n      MsgBox LC\nEnd Sub\n";
        if (explain) return "1. The first line of code declares a variable called LC as a Long data type.\n2. The second line of code sets the value of LC to the last column in the worksheet. This is done by using the Cells() function to select the cell in the first row and the last column of the worksheet, then using the End() function to move to the last column.\n3. The third line of code displays a message box with the value of LC, which is the last column in the worksheet.";
    }, [
        generate,
        explain
    ]);
    (0,react.useEffect)(function() {
        var intervalId;
        if (copied) {
            intervalId = setInterval(function() {
                setCopied(false);
            }, 1000);
        }
        return function() {
            clearInterval(intervalId);
        };
    }, [
        copied
    ]);
    var handleFeedback = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(isCorrect) {
            var res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoadingFeedback(true);
                        return [
                            4,
                            axios/* default.post */.Z.post("/api/feedback", {
                                uid: accountData === null || accountData === void 0 ? void 0 : accountData.uid,
                                id: currentVba === null || currentVba === void 0 ? void 0 : currentVba.id,
                                operation: currentVba === null || currentVba === void 0 ? void 0 : currentVba.operation,
                                type: "VBA",
                                isCorrect: isCorrect
                            }, {
                                headers: {
                                    // @ts-ignore
                                    Authorization: "Bearer ".concat(user.accessToken),
                                    ExcelBotToken: constants/* EXCEL_BOT_TOKEN */.c
                                }
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        if (res.status === 200) {
                            updateVbaFeedback(currentVba === null || currentVba === void 0 ? void 0 : currentVba.id, isCorrect);
                            setCurrentVba((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentVba), {
                                isCorrect: isCorrect
                            }));
                            setFeedbackRegistered(true);
                        } else {
                            alert("Error registering feedback");
                        }
                        setLoadingFeedback(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleFeedback(isCorrect) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var input, res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        if ((accountData === null || accountData === void 0 ? void 0 : accountData.creditBalance) <= 0 && (accountData === null || accountData === void 0 ? void 0 : accountData.isPremium) !== true) {
                            alert("You have used your monthly AI credits. Upgrade to Pro and get unlimited access!");
                            return [
                                2
                            ];
                        }
                        input = e.target.formula.value;
                        setLoading(true);
                        setCopied(false);
                        setResponse("");
                        setCurrentVba(undefined);
                        setFeedbackRegistered(false);
                        if (!generate) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            axios/* default.post */.Z.post("/api/generate-vba", {
                                vba: {
                                    id: esm_browser_v4(),
                                    prompt: input,
                                    operation: "Generate",
                                    isCorrect: null
                                },
                                uid: accountData === null || accountData === void 0 ? void 0 : accountData.uid,
                                creditBalance: !(accountData === null || accountData === void 0 ? void 0 : accountData.isPremium) ? (accountData === null || accountData === void 0 ? void 0 : accountData.creditBalance) - 1 : accountData === null || accountData === void 0 ? void 0 : accountData.creditBalance,
                                creditMax: 5
                            }, {
                                headers: {
                                    // @ts-ignore
                                    Authorization: "Bearer ".concat(user.accessToken),
                                    ExcelBotToken: constants/* EXCEL_BOT_TOKEN */.c
                                }
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            axios/* default.post */.Z.post("/api/explain-vba", {
                                vba: {
                                    id: esm_browser_v4(),
                                    prompt: input,
                                    operation: "Explain",
                                    isCorrect: null
                                },
                                uid: accountData === null || accountData === void 0 ? void 0 : accountData.uid,
                                creditBalance: !(accountData === null || accountData === void 0 ? void 0 : accountData.isPremium) ? (accountData === null || accountData === void 0 ? void 0 : accountData.creditBalance) - 1 : accountData === null || accountData === void 0 ? void 0 : accountData.creditBalance,
                                creditMax: 5
                            }, {
                                headers: {
                                    // @ts-ignore
                                    Authorization: "Bearer ".concat(user.accessToken),
                                    ExcelBotToken: constants/* EXCEL_BOT_TOKEN */.c
                                }
                            })
                        ];
                    case 3:
                        res = _state.sent();
                        _state.label = 4;
                    case 4:
                        if (res.status === 200) {
                            window.gtag("event", "vba_prompt", {
                                "prompt": input
                            });
                            addVba(res.data);
                            setCurrentVba(res.data);
                            setResponse(res.data.response);
                            if (!(accountData === null || accountData === void 0 ? void 0 : accountData.isPremium)) {
                                setCreditBalance((accountData === null || accountData === void 0 ? void 0 : accountData.creditBalance) - 1);
                            }
                        } else {
                            alert("Error generating formula - " + JSON.stringify(res.data));
                        }
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pt-5 pb-10 w-full h-full lg:scrollbar-thin lg:scrollbar-thumb-gray-500 lg:overflow-y-scroll lg:scrollbar-thumb-rounded-full lg:scrollbar-track-rounded-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "pl-8 pb-2 text-3xl font-bold border-b-2",
                children: "VBA Playground"
            }),
            oldStripeData && /*#__PURE__*/ (0,jsx_runtime.jsx)(Utils_ResubscribeCta, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "page-content-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full",
                        children: !(user === null || user === void 0 ? void 0 : user.emailVerified) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Utils_EmailVerificationCta, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                    onSubmit: handleSubmit,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm font-medium text-gray-500 mb-2 mt-10",
                                            children: "Do you want to generate VBA code or have a code explained?"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "grid gap-6 max-w-md md:grid-cols-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            checked: generate,
                                                            onChange: function(e) {
                                                                setGenerate(!generate);
                                                                setExplain(!explain);
                                                            },
                                                            type: "radio",
                                                            id: "generate",
                                                            name: "generate",
                                                            value: "generate",
                                                            className: "hidden peer"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            htmlFor: "generate",
                                                            className: "duration-300 inline-flex items-center justify-between w-full px-5 py-2 text-gray-500 bg-white border border-gray-200 rounded-xl cursor-pointer peer-checked:border-green-600 peer-checked:text-green-600 peer-checked:bg-green-200 hover:text-green-600 hover:bg-green-100",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "w-full text-lg font-semibold",
                                                                children: "Generate"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            checked: explain,
                                                            onChange: function(e) {
                                                                setGenerate(!generate);
                                                                setExplain(!explain);
                                                            },
                                                            type: "radio",
                                                            id: "explain",
                                                            name: "explain",
                                                            value: "explain",
                                                            className: "hidden peer"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            htmlFor: "explain",
                                                            className: "duration-300 inline-flex items-center justify-between w-full px-5 py-2 text-gray-500 bg-white border border-gray-200 rounded-xl cursor-pointer peer-checked:border-green-600 peer-checked:text-green-600 peer-checked:bg-green-200 hover:text-green-600 hover:bg-green-100",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "w-full text-lg font-semibold",
                                                                children: "Explain"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm font-medium text-gray-500 mb-2 mt-10",
                                            children: "Type the problem you are trying to solve or code you want explained. Be as specific as possible"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "form-control mb-5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                                className: "textarea textarea-bordered rounded-xl w-3/4 h-24 ml-2",
                                                placeholder: placeholder,
                                                name: "formula",
                                                required: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                            type: "submit",
                                            loading: loading,
                                            loadingText: "Running AI...",
                                            children: [
                                                "Get ",
                                                generate ? "Code" : "Explanation"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-sm font-medium text-gray-500 mb-2 mt-10",
                                    children: "Output"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                    className: "textarea textarea-bordered rounded-xl w-3/4 h-24 ml-2 whitespace-pre-wrap",
                                    placeholder: output,
                                    name: "output",
                                    readOnly: true,
                                    value: response,
                                    required: true
                                }),
                                response && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mb-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                                                text: response,
                                                onCopy: function() {
                                                    return setCopied(true);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    type: "button",
                                                    className: "flex items-center gap-2 p-2 mt-3 border rounded-xl ".concat(copied ? "bg-green-300" : "bg-white"),
                                                    children: [
                                                        copied ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "material-icons",
                                                                    children: "done"
                                                                }),
                                                                "Copied"
                                                            ]
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "material-icons",
                                                                    children: "content_copy"
                                                                }),
                                                                "Copy"
                                                            ]
                                                        }),
                                                        " "
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-sm font-medium text-gray-500 mb-2 mt-2",
                                                    children: "Is the output correct?"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex gap-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: "btn btn-sm btn-square btn-success ".concat(loadingFeedback && "loading"),
                                                            onClick: function() {
                                                                return handleFeedback(true);
                                                            },
                                                            disabled: feedbackRegistered,
                                                            children: !loadingFeedback && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "material-icons",
                                                                children: "thumb_up"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: "btn btn-sm btn-square btn-error ".concat(loadingFeedback && "loading"),
                                                            onClick: function() {
                                                                return handleFeedback(false);
                                                            },
                                                            disabled: feedbackRegistered,
                                                            children: !loadingFeedback && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "material-icons",
                                                                children: "thumb_down"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    (user === null || user === void 0 ? void 0 : user.emailVerified) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-8 mobile-margin-addons-block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Utils_InstallAddonCta, {
                            view: "vertical"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var VbaBuilder_VbaBuilder = (VbaBuilder);

;// CONCATENATED MODULE: ./components/TaskBuilder/TaskBuilder.tsx

















var TaskBuilder = function() {
    var user = (0,AuthContext/* useUser */.a)().user;
    var accountData = (0,store/* default */.Z)(accountSlice/* selectAccountData */.pp);
    var oldStripeData = (0,store/* default */.Z)(accountSlice/* selectOldStripeData */.DL);
    var setCreditBalance = (0,store/* default */.Z)(accountSlice/* selectAccountDataActions */.fB).setCreditBalance;
    var ref = (0,react.useState)(), currentTask = ref[0], setCurrentTask = ref[1];
    var ref1 = (0,react.useState)(true), excel = ref1[0], setExcel = ref1[1];
    var ref2 = (0,react.useState)(false), sheet = ref2[0], setSheet = ref2[1];
    var ref3 = (0,react.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,react.useState)(false), copied = ref4[0], setCopied = ref4[1];
    var ref5 = (0,react.useState)(false), loadingFeedback = ref5[0], setLoadingFeedback = ref5[1];
    var ref6 = (0,react.useState)(false), feedbackRegistered = ref6[0], setFeedbackRegistered = ref6[1];
    var ref7 = (0,react.useState)(""), response = ref7[0], setResponse = ref7[1];
    (0,react.useEffect)(function() {
        var intervalId;
        if (copied) {
            intervalId = setInterval(function() {
                setCopied(false);
            }, 1000);
        }
        return function() {
            clearInterval(intervalId);
        };
    }, [
        copied
    ]);
    var handleFeedback = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(isCorrect) {
            var res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoadingFeedback(true);
                        return [
                            4,
                            axios/* default.post */.Z.post("/api/feedback", {
                                uid: accountData === null || accountData === void 0 ? void 0 : accountData.uid,
                                id: currentTask === null || currentTask === void 0 ? void 0 : currentTask.id,
                                operation: "Generate",
                                isCorrect: isCorrect,
                                type: "Task"
                            }, {
                                headers: {
                                    // @ts-ignore
                                    Authorization: "Bearer ".concat(user.accessToken),
                                    ExcelBotToken: constants/* EXCEL_BOT_TOKEN */.c
                                }
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        if (res.status === 200) {
                            setCurrentTask((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentTask), {
                                isCorrect: isCorrect
                            }));
                            setFeedbackRegistered(true);
                        } else {
                            alert("Error registering feedback");
                        }
                        setLoadingFeedback(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleFeedback(isCorrect) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var input, res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        if ((accountData === null || accountData === void 0 ? void 0 : accountData.creditBalance) <= 0 && (accountData === null || accountData === void 0 ? void 0 : accountData.isPremium) !== true) {
                            alert("You have used your monthly AI credits. Upgrade to Pro and get unlimited access!");
                            return [
                                2
                            ];
                        }
                        input = e.target.task.value;
                        setLoading(true);
                        setCopied(false);
                        setResponse("");
                        setCurrentTask(undefined);
                        setFeedbackRegistered(false);
                        return [
                            4,
                            axios/* default.post */.Z.post("/api/task", {
                                task: {
                                    id: esm_browser_v4(),
                                    prompt: input,
                                    operation: "Generate",
                                    type: excel ? "Excel" : "Google Sheets",
                                    isCorrect: null
                                },
                                uid: accountData === null || accountData === void 0 ? void 0 : accountData.uid,
                                creditBalance: !(accountData === null || accountData === void 0 ? void 0 : accountData.isPremium) ? (accountData === null || accountData === void 0 ? void 0 : accountData.creditBalance) - 1 : accountData === null || accountData === void 0 ? void 0 : accountData.creditBalance,
                                creditMax: 5
                            }, {
                                headers: {
                                    // @ts-ignore
                                    Authorization: "Bearer ".concat(user.accessToken),
                                    ExcelBotToken: constants/* EXCEL_BOT_TOKEN */.c
                                }
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        if (res.status === 200) {
                            window.gtag("event", "task_prompt", {
                                "prompt": input
                            });
                            setCurrentTask(res.data);
                            setResponse(res.data.response);
                            if (!(accountData === null || accountData === void 0 ? void 0 : accountData.isPremium)) {
                                setCreditBalance((accountData === null || accountData === void 0 ? void 0 : accountData.creditBalance) - 1);
                            }
                        } else {
                            alert("Error generating formula - " + JSON.stringify(res.data));
                        }
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pt-5 pb-10 w-full h-full lg:scrollbar-thin lg:scrollbar-thumb-gray-500 lg:overflow-y-scroll lg:scrollbar-thumb-rounded-full lg:scrollbar-track-rounded-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "pl-8 pb-2 text-3xl font-bold border-b-2",
                children: "Task AI"
            }),
            oldStripeData && /*#__PURE__*/ (0,jsx_runtime.jsx)(Utils_ResubscribeCta, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "page-content-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full",
                        children: !(user === null || user === void 0 ? void 0 : user.emailVerified) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Utils_EmailVerificationCta, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                    onSubmit: handleSubmit,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm font-medium text-gray-500 mb-2 mt-10",
                                            children: "Is this request for Excel or Google Sheets?"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "grid gap-6 max-w-md md:grid-cols-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            checked: excel,
                                                            onChange: function(e) {
                                                                setSheet(!sheet);
                                                                setExcel(!excel);
                                                            },
                                                            type: "radio",
                                                            id: "excel",
                                                            name: "excel",
                                                            value: "excel",
                                                            className: "hidden peer"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            htmlFor: "excel",
                                                            className: "duration-300 inline-flex items-center justify-between w-full px-5 py-2 text-gray-500 bg-white border border-gray-200 rounded-xl cursor-pointer peer-checked:border-green-600 peer-checked:text-green-600 peer-checked:bg-green-200 hover:text-green-600 hover:bg-green-100",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "w-full text-lg font-semibold",
                                                                children: "Excel"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            checked: sheet,
                                                            onChange: function(e) {
                                                                setSheet(!sheet);
                                                                setExcel(!excel);
                                                            },
                                                            type: "radio",
                                                            id: "sheet",
                                                            name: "sheet",
                                                            value: "sheet",
                                                            className: "hidden peer"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            htmlFor: "sheet",
                                                            className: "duration-300 inline-flex items-center justify-between w-full px-5 py-2 text-gray-500 bg-white border border-gray-200 rounded-xl cursor-pointer peer-checked:border-green-600 peer-checked:text-green-600 peer-checked:bg-green-200 hover:text-green-600 hover:bg-green-100",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "w-full text-lg font-semibold",
                                                                children: "Google Sheets"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm font-medium text-gray-500 mb-2 mt-10",
                                            children: "Type the problem you are trying to solve. Be as specific as possible"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "form-control mb-5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                                className: "textarea textarea-bordered rounded-xl w-3/4 h-24 ml-2",
                                                placeholder: "Create a pie chart based on data from column A to D",
                                                name: "task",
                                                required: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            type: "submit",
                                            loading: loading,
                                            loadingText: "Running AI...",
                                            children: "Get Instructions"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-sm font-medium text-gray-500 mb-2 mt-10",
                                    children: "Output"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                    className: "textarea textarea-bordered rounded-xl w-3/4 h-24 ml-2 whitespace-pre-wrap",
                                    // placeholder={output}
                                    name: "output",
                                    readOnly: true,
                                    value: response,
                                    required: true
                                }),
                                response && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mb-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                                                text: response,
                                                onCopy: function() {
                                                    return setCopied(true);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    type: "button",
                                                    className: "flex items-center gap-2 p-2 mt-3 border rounded-xl ".concat(copied ? "bg-green-300" : "bg-white"),
                                                    children: [
                                                        copied ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "material-icons",
                                                                    children: "done"
                                                                }),
                                                                "Copied"
                                                            ]
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "material-icons",
                                                                    children: "content_copy"
                                                                }),
                                                                "Copy"
                                                            ]
                                                        }),
                                                        " "
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-sm font-medium text-gray-500 mb-2 mt-2",
                                                    children: "Is the output correct?"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex gap-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: "btn btn-sm btn-square btn-success ".concat(loadingFeedback && "loading"),
                                                            onClick: function() {
                                                                return handleFeedback(true);
                                                            },
                                                            disabled: feedbackRegistered,
                                                            children: !loadingFeedback && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "material-icons",
                                                                children: "thumb_up"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: "btn btn-sm btn-square btn-error ".concat(loadingFeedback && "loading"),
                                                            onClick: function() {
                                                                return handleFeedback(false);
                                                            },
                                                            disabled: feedbackRegistered,
                                                            children: !loadingFeedback && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "material-icons",
                                                                children: "thumb_down"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    (user === null || user === void 0 ? void 0 : user.emailVerified) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-8 mobile-margin-addons-block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Utils_InstallAddonCta, {
                            view: "vertical"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TaskBuilder_TaskBuilder = (TaskBuilder);

;// CONCATENATED MODULE: ./components/Dashboard/Dashboard.tsx














var Dashboard_links = [
    "smart_toy",
    "code",
    "headset_mic",
    "archive",
    "help",
    "account_circle", 
];
var UserDashboard = function(param) {
    var isLoading = param.isLoading;
    var ref = (0,AuthContext/* useUser */.a)(), user = ref.user, logOut = ref.logOut;
    var creditBalance = (0,store/* default */.Z)(accountSlice/* selectCreditBalance */.Iv);
    var accountData = (0,store/* default */.Z)(accountSlice/* selectAccountData */.pp);
    var ref1 = (0,react.useState)(0), tab = ref1[0], setTab = ref1[1];
    var router = (0,next_router.useRouter)();
    var tabQueryParam = Array.isArray(router.query.tabQueryParam) ? router.query.tabQueryParam[0] : router.query.tabQueryParam;
    var tabNumber = tabQueryParam ? parseInt(tabQueryParam, 10) : 0;
    (0,react.useEffect)(function() {
        if (tabNumber) {
            setTab(tabNumber);
        }
    }, [
        tabNumber
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            creditBalance === 0 && (accountData === null || accountData === void 0 ? void 0 : accountData.isPremuim) === false && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-8 bg-error text-error-content text-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "font-semibold cursor-pointer",
                    onClick: function() {
                        return setTab(3);
                    },
                    children: "0 Credits left. Upgrade to premium to get unlimited access!"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden lg:block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dashboard_LeftPanel, {
                            user: user,
                            tab: tab,
                            setTab: setTab
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "btm-nav z-40 h-16 lg:hidden",
                        children: [
                            Dashboard_links.map(function(link, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: function() {
                                        return setTab(i);
                                    },
                                    className: "w-[14%] ".concat(tab === i ? "active bg-green-300" : ""),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "rounded-none",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "material-icons",
                                            children: link
                                        })
                                    })
                                }, i);
                            }),
                            user && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "w-[14%]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "rounded-none",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "material-icons",
                                                    children: "home"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "w-[14%]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "rounded-none",
                                            onClick: function() {
                                                return logOut();
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "material-icons",
                                                children: "logout"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    !isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "h-screen w-full bg-gray-100 scrollbar-thin scrollbar-thumb-gray-500 overflow-y-scroll overflow-x-hidden scrollbar-thumb-rounded-full scrollbar-track-rounded-full px-8 pb-20 lg:pb-0 lg:px-0",
                        children: [
                            tab === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Query_QueryBuilder, {}),
                            tab === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(VbaBuilder_VbaBuilder, {}),
                            tab === 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TaskBuilder_TaskBuilder, {}),
                            tab === 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Archive_Archive, {}),
                            tab === 4 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Help_HelpTab, {}),
                            tab === 5 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile_Profile, {})
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        role: "status",
                        className: "max-w-sm animate-pulse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-4 bg-base-200 rounded-full w-96 my-4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-3 bg-base-200 rounded-full max-w-[360px] my-2.5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-3 bg-base-200 rounded-full my-2.5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-2 bg-base-200 rounded-full max-w-[330px] my-2.5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-3 bg-base-200 rounded-full max-w-[300px] my-2.5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-3 bg-base-200 rounded-full max-w-[360px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-4 bg-base-200 rounded-full w-96 my-4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-3 bg-base-200 rounded-full max-w-[360px] my-2.5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-3 bg-base-200 rounded-full my-2.5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-2 bg-base-200 rounded-full max-w-[330px] my-2.5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-3 bg-base-200 rounded-full max-w-[300px] my-2.5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-3 bg-base-200 rounded-full max-w-[360px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-4 bg-base-200 rounded-full w-96 my-4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-3 bg-base-200 rounded-full max-w-[360px] mb-2.5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-3 bg-base-200 rounded-full mb-2.5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-2 bg-base-200 rounded-full max-w-[330px] mb-2.5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-3 bg-base-200 rounded-full max-w-[300px] mb-2.5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-3 bg-base-200 rounded-full max-w-[360px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-3 bg-base-200 rounded-full mb-2.5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-2 bg-base-200 rounded-full max-w-[330px] mb-2.5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-3 bg-base-200 rounded-full max-w-[300px] mb-2.5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-3 bg-base-200 rounded-full max-w-[360px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-3 bg-base-200 rounded-full mb-2.5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-2 bg-base-200 rounded-full max-w-[330px] mb-2.5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-3 bg-base-200 rounded-full max-w-[300px] mb-2.5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-3 bg-base-200 rounded-full max-w-[360px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "sr-only",
                                children: "Loading..."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Dashboard = (UserDashboard);

;// CONCATENATED MODULE: ./components/Dashboard/index.ts


;// CONCATENATED MODULE: ./pages/dashboard.tsx












var dashboard_Dashboard = function() {
    var ref = (0,AuthContext/* useUser */.a)(), user = ref.user, loading = ref.loading;
    var ref1 = (0,next_router.useRouter)(), session_id = ref1.query.session_id, push = ref1.push;
    var ref2 = (0,store/* default */.Z)(accountSlice/* selectAccountDataActions */.fB), setAccountData = ref2.setAccountData, setOldStripeData = ref2.setOldStripeData;
    var ref3 = (0,store/* default */.Z)(archiveSlice/* selectArchiveDataActions */.sD), setAllQueries = ref3.setAllQueries, setAllVba = ref3.setAllVba;
    var creditBalance = (0,store/* default */.Z)(accountSlice/* selectCreditBalance */.Iv);
    var ref4 = (0,react.useState)(false), isLoadingData = ref4[0], setIsLoadingData = ref4[1];
    (0,react.useEffect)(function() {
        if (loading) {
            setIsLoadingData(true);
        }
        if (user && !session_id && (user === null || user === void 0 ? void 0 : user.uid)) {
            setIsLoadingData(true);
            axios/* default.post */.Z.post("/api/data", {
                id: user.uid,
                email: user.email
            }, {
                headers: {
                    // @ts-ignore
                    Authorization: "Bearer ".concat(user.accessToken),
                    ExcelBotToken: constants/* EXCEL_BOT_TOKEN */.c
                }
            }).then(function(res) {
                setAccountData(res.data.account);
                setAllQueries(res.data.all);
                setAllVba(res.data.vba);
                setOldStripeData(res.data.oldStripeData);
            }).catch(function(err) {
                console.log(err);
                alert(err.message);
            });
            setIsLoadingData(false);
        }
    }, [
        user,
        session_id,
        creditBalance,
        push,
        loading,
        setAccountData,
        setAllQueries,
        setAllVba,
        setOldStripeData, 
    ]);
    (0,react.useEffect)(function() {
        if (session_id && user) {
            push("/dashboard");
        }
    }, [
        push,
        session_id,
        user
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "Dashboard | AI Excel Bot",
                description: "AI Excel Bot helps you create complex Excel formulas in seconds. Use simple English prompts to generate formulas. AI Excel Bot's formula generator uses state of the art GPT-3 AI model to give you the best results.",
                canonical: "https://aiexcelbot.com/dashboard",
                openGraph: {
                    url: "https://aiexcelbot.com/dashboard",
                    title: "Dashboard | AI Excel Bot",
                    description: "AI Excel Bot helps you create complex Excel formulas in seconds. Use simple English prompts to generate formulas. AI Excel Bot's formula generator uses state of the art GPT-3 AI model to give you the best results.",
                    images: [
                        {
                            url: "https://aiexcelbot.com/dashboard-hero.png"
                        }, 
                    ],
                    siteName: "AI Excel Bot"
                },
                twitter: {
                    handle: "@0x_gautam",
                    cardType: "summary_large_image"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "g-tag-conversion",
                children: "gtag('event', 'conversion', {'send_to': 'AW-10784667441/oWPKCKeWnYUYELHuw5Yo'}); "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                className: "max-w-[1920px] m-auto",
                children: !loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: user ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Dashboard, {
                        isLoading: isLoadingData
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-screen w-screen flex items-center justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "btn btn-error",
                            onClick: function() {
                                return push("/login");
                            },
                            children: "Login to access Dashboard"
                        })
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-screen flex justify-center items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("progress", {
                        className: "progress progress-success w-56"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var dashboard = (dashboard_Dashboard);


/***/ }),

/***/ 896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ pricing; }
/* harmony export */ });
var pricing = [
    {
        title: "Free",
        price: "$0",
        priceId: "",
        benefits: [
            "Limited access to AI Excel Bot",
            "5 Formula, Code or Task generation and explaination per month",
            "Access to our Chrome extension",
            "email support", 
        ],
        isLocal: true,
        displayLoggedIn: false,
        displayLoggedOut: true,
        paypal_plan_id: ""
    },
    {
        title: "Pro",
        price: "$2.99",
        priceId: "price_1N9V3kGUC8HbciH8V3AYQDLA" || 0,
        benefits: [
            "Full access to AI Excel Bot",
            "Access to our Chrome extension",
            "Access to our Excel add-in",
            "Unlimited Formula generation per month",
            "Unlimited Formula explanations per month",
            "Unlimited VBA code generations per month",
            "Unlimited VBA code explanations per month",
            "Unlimited Task explanations per month",
            "Priority support", 
        ],
        isLocal: false,
        isAnnual: false,
        displayLoggedIn: true,
        displayLoggedOut: true,
        paypal_plan_id: "P-8BD58547AW035211PMWB5UQY" || 0
    },
    {
        title: "Pro Annual",
        price: "$24.99",
        priceId: "price_1N9V3kGUC8HbciH8QiTgWon4" || 0,
        benefits: [
            "Full access to AI Excel Bot",
            "Access to our Chrome extension",
            "Access to our Excel add-in",
            "Unlimited Formula generation per month",
            "Unlimited Formula explanations per month",
            "Unlimited VBA code generations per month",
            "Unlimited VBA code explanations per month",
            "Unlimited Task explanations per month",
            "Priority support", 
        ],
        isLocal: false,
        isAnnual: true,
        displayLoggedIn: true,
        displayLoggedOut: true,
        paypal_plan_id: "P-85H46737P0848741XMWB5VFQ" || 0
    }, 
];


/***/ }),

/***/ 4300:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CopyToClipboard = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _copyToClipboard = _interopRequireDefault(__webpack_require__(640));

var _excluded = ["text", "onCopy", "options", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CopyToClipboard = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(CopyToClipboard, _React$PureComponent);

  var _super = _createSuper(CopyToClipboard);

  function CopyToClipboard() {
    var _this;

    _classCallCheck(this, CopyToClipboard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
      var _this$props = _this.props,
          text = _this$props.text,
          onCopy = _this$props.onCopy,
          children = _this$props.children,
          options = _this$props.options;

      var elem = _react["default"].Children.only(children);

      var result = (0, _copyToClipboard["default"])(text, options);

      if (onCopy) {
        onCopy(text, result);
      } // Bypass onClick if it was present


      if (elem && elem.props && typeof elem.props.onClick === 'function') {
        elem.props.onClick(event);
      }
    });

    return _this;
  }

  _createClass(CopyToClipboard, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _text = _this$props2.text,
          _onCopy = _this$props2.onCopy,
          _options = _this$props2.options,
          children = _this$props2.children,
          props = _objectWithoutProperties(_this$props2, _excluded);

      var elem = _react["default"].Children.only(children);

      return /*#__PURE__*/_react["default"].cloneElement(elem, _objectSpread(_objectSpread({}, props), {}, {
        onClick: this.onClick
      }));
    }
  }]);

  return CopyToClipboard;
}(_react["default"].PureComponent);

exports.CopyToClipboard = CopyToClipboard;

_defineProperty(CopyToClipboard, "defaultProps", {
  onCopy: undefined,
  options: undefined
});

/***/ }),

/***/ 4855:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(4300),
    CopyToClipboard = _require.CopyToClipboard;

CopyToClipboard.CopyToClipboard = CopyToClipboard;
module.exports = CopyToClipboard;

/***/ }),

/***/ 1742:
/***/ (function(module) {


module.exports = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [664,70,962,774,888,179], function() { return __webpack_exec__(528); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);